module.exports = __webpack_public_path__ + "static/media/deep.7888438a.png";